import { Container, Button } from "react-bootstrap";
import "../home.css";
import { useScroll } from "../../../context/scroll-context";

const HomeHero = () => {
  const { scrollToSection, contactform } = useScroll();

  const handleScrollAndClose = (refName) => {
    scrollToSection(refName);
  };
  return (
    <>
      <section className="home-hero-wrapper">
        <Container fluid>
          <div className="title-wrapper">
            <h1 className="text-white mb-2 mb-lg-4 ft-wt-700">
              Grow And Scale Your Business With Your Dream Tech Team
            </h1>
            <h3 className="text-white fw-normal mb-5">
              Helping Inc. 5000 companies, startups, and businesses looking to
              scale to the next level.
            </h3>
            <Button
              className=""
              variant="secondary"
              onClick={() => handleScrollAndClose(contactform)}
            >
              GET STARTED
            </Button>
          </div>
        </Container>
      </section>
    </>
  );
};

export default HomeHero;
